import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getAbout } from "../../services/Admin/adminServices";
import { useNavigate } from "react-router-dom";
import { FiEdit, FiInfo, FiFileText, FiCheckCircle } from "react-icons/fi";

const About = () => {
  const [infos, setInfos] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const roleData = useSelector((state) => state.role.roles);

  const canUpdate = roleData
    ? roleData?.legalPagesManagement?.isUpdate
    : true;

  // Fetch data
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getAbout();
      setInfos(response?.data?.data?.aboutUs || null);
    } catch (error) {
      console.error("Error fetching about info:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditClick = (info) => {
    navigate("/admin/about-form", {
      state: { info, isEditMode: true },
    });
  };

  const handleAddNew = () => {
    navigate("/admin/about-form", {
      state: { info: null, isEditMode: false },
    });
  };

  return (
    <div className="container-fluid p-0">
      {/* Page Header */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4">
        <div>
          <div className="d-flex align-items-center gap-2">
            <h2 className="fw-bold mb-0" style={{ color: "#E5484D" }}>
              About Us
            </h2>
           
          </div>
        
        </div>

        {canUpdate && infos && (
          <button
            className="btn d-inline-flex align-items-center gap-2 shadow-sm px-3 py-2 text-white fw-medium"
            style={{
              backgroundColor: "#E5484D",
              borderColor: "#E5484D",
              borderRadius: "0.5rem",
            }}
            onClick={() => handleEditClick(infos)}
          >
            <FiEdit size={16} /> Edit Content
          </button>
        )}
      </div>

      {/* Loading State */}
      {loading ? (
        <div
          className="card border-0 shadow-sm p-5 text-center my-4"
          style={{ borderRadius: "1rem", backgroundColor: "#fff" }}
        >
          <div className="py-4">
            <Spinner animation="border" style={{ color: "#E5484D" }} role="status" />
            <p className="mt-3 text-muted mb-0">Loading About Us content...</p>
          </div>
        </div>
      ) : !infos ? (
        /* Empty State */
        <div
          className="card border-0 shadow-sm p-5 text-center my-4"
          style={{ borderRadius: "1rem", backgroundColor: "#fff" }}
        >
          <div className="py-4 max-w-md mx-auto">
            <div
              className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
              style={{ width: "64px", height: "64px", backgroundColor: "#FFE4E6", color: "#E5484D" }}
            >
              <FiFileText size={32} />
            </div>
            <h5 className="fw-bold mb-2">No About Us Content Found</h5>
            <p className="text-muted mb-4" style={{ fontSize: "14px" }}>
              There is currently no About Us content published. Click the button below to add content.
            </p>
            {canUpdate && (
              <button
                className="btn text-white fw-medium px-4 py-2"
                style={{
                  backgroundColor: "#E5484D",
                  borderRadius: "0.5rem",
                  border: "none",
                }}
                onClick={handleAddNew}
              >
                Add About Us Content
              </button>
            )}
          </div>
        </div>
      ) : (
        /* Main Content Card */
        <div
          className="card border-0 shadow-sm overflow-hidden"
          style={{ borderRadius: "1rem", backgroundColor: "#fff" }}
        >
         

          {/* HTML Body Container */}
          <div className="card-body p-4 p-md-5">
            <div
              className="about-content-preview"
              style={{
                fontSize: "15px",
                lineHeight: "1.8",
                color: "#2D3748",
              }}
              dangerouslySetInnerHTML={{ __html: infos }}
            />
          </div>
        </div>
      )}

      {/* Scoped CSS for Rich Content styling */}
      <style>{`
        .about-content-preview h1,
        .about-content-preview h2,
        .about-content-preview h3,
        .about-content-preview h4 {
          color: #1A202C;
          font-weight: 700;
          margin-top: 1.5rem;
          margin-bottom: 0.75rem;
        }
        .about-content-preview h1 { font-size: 1.75rem; }
        .about-content-preview h2 { font-size: 1.5rem; }
        .about-content-preview h3 { font-size: 1.25rem; }
        .about-content-preview p {
          margin-bottom: 1.25rem;
        }
        .about-content-preview ul,
        .about-content-preview ol {
          padding-left: 1.5rem;
          margin-bottom: 1.25rem;
        }
        .about-content-preview li {
          margin-bottom: 0.5rem;
        }
        .about-content-preview img {
          max-width: 100%;
          height: auto;
          border-radius: 0.75rem;
          margin: 1rem 0;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }
        .about-content-preview blockquote {
          border-left: 4px solid #E5484D;
          padding: 0.75rem 1rem;
          margin-left: 0;
          color: #4A5568;
          font-style: italic;
          background: #FFF5F5;
          border-radius: 0 0.5rem 0.5rem 0;
          margin-bottom: 1.25rem;
        }
      `}</style>
    </div>
  );
};

export default About;
